const pad = (n) => String(n).padStart(2, "0");
const ymd = (d) => `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}`;

export function downloadInitiativeIcs(init, { t, lang, publicUrl } = {}) {
  if (!init?.start_date) return;
  const s = new Date(init.start_date + "T00:00:00");
  const e = new Date((init.end_date || init.start_date) + "T00:00:00");
  e.setDate(e.getDate() + 1); // DTEND exclusive for all-day events
  const esc = (v) => (v || "").replace(/\\/g, "\\\\").replace(/;/g, "\\;").replace(/,/g, "\\,").replace(/\n/g, "\\n");
  const modalityLabel = (init.online_required && init.in_person_required)
    ? t("initiatives.online_and_in_person")
    : init.online_required ? t("common.online") : init.in_person_required ? t("common.in_person") : "";
  const url = publicUrl || `${window.location.origin}/iniciativas/${init.id}`;
  const now = new Date();
  const stamp = `${ymd(now)}T${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
  const desc = [init.description, modalityLabel ? `${t("initiatives.format_label_display")}: ${modalityLabel}` : "", url].filter(Boolean).join("\n");
  const ics = [
    "BEGIN:VCALENDAR", "VERSION:2.0", "PRODID:-//ConQuienHoy//Initiatives//EN", "CALSCALE:GREGORIAN",
    "BEGIN:VEVENT", `UID:conquienhoy-${init.id}@conquienhoy.com`, `DTSTAMP:${stamp}`,
    `DTSTART;VALUE=DATE:${ymd(s)}`, `DTEND;VALUE=DATE:${ymd(e)}`,
    `SUMMARY:${esc(init.name)}`, init.location ? `LOCATION:${esc(init.location)}` : "",
    `DESCRIPTION:${esc(desc)}`, `URL:${url}`, "END:VEVENT", "END:VCALENDAR",
  ].filter(Boolean).join("\r\n");
  const blob = new Blob([ics], { type: "text/calendar;charset=utf-8" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = `${(init.name || "initiative").replace(/[^a-z0-9]+/gi, "_")}.ics`;
  document.body.appendChild(a); a.click(); a.remove();
  URL.revokeObjectURL(a.href);
}
